/* Step 12-F5a · G7b (owner's G7 Addendum V2 point 3; coordinator 23:35 KSA) — the sampling screen names the standard without an
   unverified paragraph number (was "ISA 500.A55–A56", "ISA 500 A56", "ISA 530 A3" — the owner's Step 7 references, never
   checked against the standards' text). EN + AR; the stored method names (identifiers of saved samples) are unchanged. */
const I18N_S12F5A_SAMPLING = {
  en: {
    samplingMethods: {
      "Specific vouching - ISA 500.A55–A56": "Specific vouching – ISA 500",
      "Specific vouching - ISA 500.A53": "Specific vouching – ISA 500",
    },
    sampling: {
      tmReasonPh: "e.g. a sample-specific tolerable misstatement (ISA 530)",
    },
    s7a: {
      specificMethod: "Specific vouching – ISA 500",
      specificLine: "Selecting specific items — not sampling; results are not projected (ISA 500).",
      restOfPopulation: "The rest of the population is not covered by this selection — obtain other evidence (e.g. analytics or a separate sample).",
    },
  },
  ar: {
    samplingMethods: {
      "Specific vouching - ISA 500.A55–A56": "التدقيق المستندي لبنود محددة – معيار المراجعة الدولي 500",
      "Specific vouching - ISA 500.A53": "التدقيق المستندي لبنود محددة – معيار المراجعة الدولي 500",
    },
    sampling: {
      tmReasonPh: "مثال: تحريف مقبول خاص بالعينة (معيار المراجعة الدولي 530)",
    },
    s7a: {
      specificMethod: "التدقيق المستندي لبنود محددة – معيار المراجعة الدولي 500",
      specificLine: "اختيار بنود محددة — ليس معاينة؛ لا تُسقَط النتائج على المجتمع (معيار المراجعة الدولي 500).",
      restOfPopulation: "بقية المجتمع لا يغطيها هذا الاختيار — احصل على أدلة أخرى (مثل الإجراءات التحليلية أو عينة منفصلة).",
    },
  },
};

export default I18N_S12F5A_SAMPLING;
